import { STAGE_COLORS, PRIORITY_COLORS, STATUS_COLORS } from "./colors";

// ── Stage Definitions ───────────────────────────────────────────────
export const STAGES = [
  {
    id: "backlog",
    label: "Requisitions",
    short: "REQ",
    color: STAGE_COLORS.backlog,
    key: "requisition",
    hidden: true,
  },
  {
    id: "po_issued",
    label: "PO Issued",
    short: "PO",
    color: STAGE_COLORS.po_issued,
    key: "poIssued",
  },
  {
    id: "supplier_confirmed",
    label: "Supplier Confirmed",
    short: "SUP",
    color: STAGE_COLORS.supplier_confirmed,
    key: "supplierConfirmed",
    hidden: true,
  },
  {
    id: "inventory_ready",
    label: "Inventory Ready",
    short: "RDY",
    color: STAGE_COLORS.inventory_ready,
    key: "inventoryReady",
    hidden: true,
  },
  {
    id: "in_transit",
    label: "PO In Transit",
    short: "TRN",
    color: STAGE_COLORS.in_transit,
    key: "inTransit",
  },
  {
    id: "receiving",
    label: "PO Receiving",
    short: "RCV",
    color: STAGE_COLORS.receiving,
    key: "receiving",
  },
  {
    id: "in_stock",
    label: "PO Stock in",
    short: "INV",
    color: STAGE_COLORS.in_stock,
    key: "inStock",
  },
  {
    id: "fulfillment",
    label: "Fulfillment",
    short: "FUL",
    color: STAGE_COLORS.fulfillment,
    key: "fulfillment",
  },
  {
    id: "pending_delivery",
    label: "Pending Delivery",
    short: "PDL",
    color: STAGE_COLORS.pending_delivery,
    key: "pendingDelivery",
  },
];

// Stages actually rendered on the board / pipeline / metrics views. Hidden
// stages stay in STAGES so id⇄key resolution and the drag-transition maps keep
// working, but they get no column.
export const VISIBLE_STAGES = STAGES.filter((s) => !s.hidden);

// ── Priorities ──────────────────────────────────────────────────────
export const PRIORITIES = {
  critical: {
    label: "Q1",
    color: PRIORITY_COLORS.critical.text,
    bg: PRIORITY_COLORS.critical.bg,
  },
  high: {
    label: "Q2",
    color: PRIORITY_COLORS.high.text,
    bg: PRIORITY_COLORS.high.bg,
  },
  medium: {
    label: "Q3",
    color: PRIORITY_COLORS.medium.text,
    bg: PRIORITY_COLORS.medium.bg,
  },
  low: {
    label: "Q4",
    color: PRIORITY_COLORS.low.text,
    bg: PRIORITY_COLORS.low.bg,
  },
};

// ── Statuses ────────────────────────────────────────────────────────
export const STATUS = {
  on_track: { icon: "▲", color: STATUS_COLORS.on_track, label: "On Track" },
  at_risk: { icon: "◆", color: STATUS_COLORS.at_risk, label: "At Risk" },
  blocked: { icon: "■", color: STATUS_COLORS.blocked, label: "Blocked" },
};

// ── Average Cycle Times (days) ──────────────────────────────────────
export const CYCLE_TIME_AVG = {
  backlog: 2,
  sourcing: 4,
  po_issued: 6,
  in_transit: 9,
  receiving: 2,
  in_stock: 14,
  fulfillment: 2,
  pending_delivery: 0,
};

// ── View Tabs ───────────────────────────────────────────────────────
export const VIEW_TABS = ["board", "pipeline", "metrics"];
